import { Component, OnInit } from '@angular/core';
import { APICallService } from 'src/app/services/api-call.service';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { DialogMsgComponent } from '../../common/dialog-msg/dialog-msg.component';
import { LineLovDialogComponent } from '../../common/line-lov-dialog/line-lov-dialog.component';
import { PerilLovComponent } from '../../common/peril-lov/peril-lov.component';
import { FormService } from 'src/app/services/form.service';
import { JsonDataService } from 'src/app/services/json-data.service';
import { AppMessageService } from 'src/app/services/app-message.service';
import { DialogBoxService } from 'src/app/services/dialog-box.service';
import { UserDetailsService } from 'src/app/services/user-details.service';
import { forkJoin, Observable } from 'rxjs';
import { LeaveConfirmation } from '../../common/guard/check.guard';
import { SecurityService } from 'src/app/services/security.service'; 
import { ClientGroupLovDialog } from '../../common/client-group-lov-dialog/client-group-lov-dialog.component';
import { ClassLovComponent } from '../../common/class-lov/class-lov.component';
import { EQZoneLovComponent } from '../../common/eq-zone-lov/eq-zone-lov.component';
import { TyphoonZoneLovComponent } from '../../common/typhoon-zone-lov/typhoon-zone-lov.component';
import { FloodZoneLovComponent } from '../../common/flood-zone-lov/flood-zone-lov.component';
@Component({
  selector: 'fire-cat-perils-premium-rates-per-client-group-maintenance',
  templateUrl: './fire-cat-perils-premium-rates-per-client-group-maintenance.component.html',
  styleUrls: ['./fire-cat-perils-premium-rates-per-client-group-maintenance.component.css']
})
export class FireCatPerilsPremiumRatesPerClientGroupMaintenanceComponent implements OnInit, LeaveConfirmation {
  
  datePipe = new DatePipe('en-us');

  addDisabled : boolean = true;
  saveDisabled : boolean = true;
  deleteDisabled : boolean = true;
  tranPosted : boolean = false;
  noLoadingInProcess : boolean = true;
  validated : boolean = false;
  userIDReadOnly : boolean = false;
  isLineSelected : boolean = false;
  pubUserStdRatesCodeField: string = '';
  currentUser: string = this.jsonDataService.retrieveFromStorage('userId');
  rowClickedData: any;
  selectedData : any = null;
  moduleId: string = 'BMM169';
  perilDisabled: boolean = true;
  moduleName: string = '';
  paramVList: any = [];
  paramV: string= '';
  catZoneDisabled: boolean = true;

  selectedClientGrp: any = {
    CLIENT_CD: '',
    CLIENT_DESC: '',
    CLIENT_FIELD: ''
  };
  selectedLine: any = {
    LINE_CD: '',
    LINE_NAME: '',
    LINE_FIELD: ''
  };

  selectedClass: any = {
    CLASS_CD: '',
    CLASS_DESC: '',
    CLASS_FIELD: ''
  };

  selectedPeril: any = {
    PERIL_CD:'',
    PERIL_LNAME:'',
    PERIL_FIELD:''
  };

  selectedCatZone: any = {
    CAT_ZONE_CD:'',
    CAT_ZONE_DESC:'',
    CAT_ZONE_FIELD:''
  };
  tempAddedData: any = [];
  tempUpdateData: any = [];

  paramForm = this.formBuilder.group({
    clientGrpCd: [null],
    clientGrpDesc: [null],
    clientGrpField: [null],
    lineCd: [null],
    lineName: [null],
    lineField: [null],
    classCd: [null],
    classDesc: [null],
    classField: [null],
    catZoneCd:[null],
    catZoneDesc:[null],
    catZoneField:[null],
    perilCd:[null],
    perilName:[null],
    perilField:[null]
  });
  fireCatPerilsPremRatesPerClientGroupForm = this.formBuilder.group({
    numOfFloor: [null, [Validators.required]],
    premiumRate: [null, [Validators.required, Validators.maxLength(13)]],
    activeTag: ['A', [Validators.required]],
    commissionRate: [null, [Validators.required, Validators.maxLength(13)]],
    defaultTag: ['No', [Validators.required]],
    effDateFrom: [new Date(), [Validators.required]],
    effDateTo: [null],
    remarks: [null],
    userID: [null],
    lastUserUpdate: [null]
  });

  constructor(
    private apiCallService: APICallService,
    public _Dialog: MatDialog, 
    private userDetailService: UserDetailsService,
    private formService: FormService, 
    private formBuilder: FormBuilder, 
    private appMessageService: AppMessageService,
    private jsonDataService: JsonDataService,
    private securityService: SecurityService
  ) {  
    this.moduleName = this.jsonDataService.data.moduleList.filter((data: any) => { return data.moduleId === this.moduleId })[0].moduleDesc.toUpperCase();
    this.paramVList = this.jsonDataService.data.params.filter((item:any)=>{ return item.paramName == "CAT_PERIL_EQ" || item.paramName == "CAT_PERIL_TY" || item.paramName == "CAT_PERIL_FL"});
  }

  canDeactivate(): Observable<boolean> | boolean {
    if(this.tempAddedData!='' || this.tempUpdateData!='') {
      return false;
    } else {
      return true;
    }
  }

  fireCatPerilsPremRatesPerClientGroupTblConfig: any = {
    cols: [
      {
        key: "NO_OF_FLOOR",
        header: "No. of Floors",
        dataType: "integer"
      },
      {
        key: "PREM_RT",
        header: "Premium Rate",
        dataType: "rateDecimal"
      },
      {
        key: "EFF_DATE_FROM",
        header: "Effective Date",
        dataType: "date"
      },
      {
        key: "EFF_DATE_TO",
        header: "Expiry Date",
        dataType: "date"
      },
      {
        key: "COMM_RT",
        header: "Comission Rate",
        dataType: "rateDecimal"
      },
      {
        key: "DEFAULT_TAG",
        header: "Default",
        dataType: "string",
        width: '13%'
      },
      {
        key: "ACTIVE_TAG",
        header: "A",
        dataType: "checkbox",
        width: '8%'
      }
    ],
    tblData: [],
    selection: "single",
    paginator: true,
    rowsPerPage: 10,
    lazy: false,
    totalRecords: 15,
    loading: false,
  }
  ngOnInit() {
  }

  initOnGet(): void {
    try {
      this.apiCallService.refreshNeeded$
            .subscribe(() => {
              this.getAllFireCatPerilsPremRatesPerClientGroup();
          });
      this.getAllFireCatPerilsPremRatesPerClientGroup();
    }
    catch(e) {
    }
  }

  async getAllFireCatPerilsPremRatesPerClientGroup(){
    try{
      let clientGrpCd = this.paramForm.get('clientGrpCd')?.value;
      let lineCd = this.paramForm.get('lineCd')?.value;
      let classCd = this.paramForm.get('classCd')?.value;
      let perilCd = this.paramForm.get('perilCd')?.value;
      let catZoneCd = this.paramForm.get('catZoneCd')?.value;
      if (clientGrpCd && lineCd && classCd&& perilCd&& catZoneCd ) {
        const params = {
          queryParams:{
            clientGrpCd: clientGrpCd,
            classCd: classCd,
            lineCd: lineCd,
            perilCd: perilCd,
            catZoneCd: catZoneCd,
          },
          moduleId: this.moduleId,
          userId: this.userDetailService.userId,
          type: "MODULE"
        }
        this.fireCatPerilsPremRatesPerClientGroupTblConfig.loading = true;
        this.apiCallService.getFireCatPremiumRatesPerClientGroup(params).subscribe({
          next: (data: any) => {
            this.securityService.checkRequestKeyResponse(data, ()=>{
              this.securityService.hasValidCsrfToken(data, ()=>{
                data = JSON.parse(this.jsonDataService.decrypt(data.response));
                let rawData:any = [];
                let finalData:any = [];
                if(!Array.isArray(data)){
                  rawData.push(data);
                }
                else{
                  rawData = data;
                }
                // finalData = this.populateTempData(finalData, rawData);
                if(rawData.length>1){
                  for(let item of rawData){
                    if(item.DEFAULT_TAG.toUpperCase()=='Y'){
                      item.DEFAULT_TAG = 'Yes';
                    }else{
                      item.DEFAULT_TAG= 'No';
                    }
                  }
                }
                else if(rawData.length==1){
                  for(let item of rawData){
                    if(item.DEFAULT_TAG.toUpperCase()=='Y'){
                      item.DEFAULT_TAG = 'Yes';
                    }else{
                      item.DEFAULT_TAG= 'No';
                    }
                  }
                }
                this.fireCatPerilsPremRatesPerClientGroupTblConfig.tblData = rawData;
                this.fireCatPerilsPremRatesPerClientGroupTblConfig.loading = false;
                this.tempAddedData = [];
                this.tempUpdateData = [];
                this.saveDisabled = this.saveChecker();
              });
            });
          },
          error: (e: any) => {
            this.fireCatPerilsPremRatesPerClientGroupTblConfig.loading = false;
          }
        });
      } else{
        this.fireCatPerilsPremRatesPerClientGroupTblConfig.loading = true;
        this.fireCatPerilsPremRatesPerClientGroupTblConfig.tblData = [];
        this.fireCatPerilsPremRatesPerClientGroupTblConfig.loading = false;
        this.tempAddedData = [];
        this.tempUpdateData = [];
        this.saveDisabled = this.saveChecker();
      }
    }catch(e){
    }
  }

  updateLine() {
    try {
      this.tranPosted = true;
      this.validateUpdate();
      if (this.validated) {
        this.updateFormTable();
      }
    }
    catch(e) {
    }
  }
  updateFormTable() {
    try {
      let fieldNumOfFloor = this.fireCatPerilsPremRatesPerClientGroupForm.get('numOfFloor')?.value;
      let fieldPremRate = this.fireCatPerilsPremRatesPerClientGroupForm.get('premiumRate')?.value;
      let fieldEffDateTo = this.fireCatPerilsPremRatesPerClientGroupForm.get('effDateTo')?.value? this.datePipe.transform(new Date(this.fireCatPerilsPremRatesPerClientGroupForm.get('effDateTo')?.value), 'yyyy-MM-dd'): null;
      let fieldEffDateFrom = new Date(this.fireCatPerilsPremRatesPerClientGroupForm.get('effDateFrom')?.value);
      let tempInsertChecker = this.tempAddedData.find((item: { NO_OF_FLOOR: any, PREM_RT: any, EFF_DATE_FROM:any }) => 
        +item.NO_OF_FLOOR==+fieldNumOfFloor&&+item.PREM_RT==+fieldPremRate&&getDateNum(new Date(item.EFF_DATE_FROM))==getDateNum(fieldEffDateFrom)
      );
      let tempUpdateChecker = this.tempUpdateData.find((item: { NO_OF_FLOOR: any, PREM_RT: any, EFF_DATE_FROM:any }) => 
        +item.NO_OF_FLOOR==+fieldNumOfFloor&&+item.PREM_RT==+fieldPremRate&&getDateNum(new Date(item.EFF_DATE_FROM))==getDateNum(fieldEffDateFrom)
      );
      
      this.tableDataUpdate();
      // Adds Updated Data that exists in the database to an object array for updated datas
      if(tempInsertChecker!=null && tempInsertChecker!='') {
        //this.tempUpdateData.push(this.formValueToData());
        tempInsertChecker.CLIENT_CD= this.paramForm.get('clientGrpCd')?.value;
        tempInsertChecker.CLASS_CD= this.paramForm.get('classCd')?.value;
        tempInsertChecker.LINE_CD= this.paramForm.get('lineCd')?.value;
        tempInsertChecker.PERIL_CD= this.paramForm.get('perilCd')?.value;
        tempInsertChecker.CAT_ZONE_CD= this.paramForm.get('catZoneCd')?.value;
        tempInsertChecker.NO_OF_FLOOR= +this.fireCatPerilsPremRatesPerClientGroupForm.get('numOfFloor')?.value;
        tempInsertChecker.PREM_RT = +this.fireCatPerilsPremRatesPerClientGroupForm.get('premiumRate')?.value;
        tempInsertChecker.ACTIVE_TAG = this.fireCatPerilsPremRatesPerClientGroupForm.get('activeTag')?.value;
        tempInsertChecker.COMM_RT = +this.fireCatPerilsPremRatesPerClientGroupForm.get('commissionRate')?.value;
        tempInsertChecker.DEFAULT_TAG = this.fireCatPerilsPremRatesPerClientGroupForm.get('defaultTag')?.value;
        tempInsertChecker.EFF_DATE_FROM = this.datePipe.transform(new Date(this.fireCatPerilsPremRatesPerClientGroupForm.get('effDateFrom')?.value), 'yyyy-MM-dd');
        tempInsertChecker.EFF_DATE_TO = fieldEffDateTo;
        tempInsertChecker.REMARKS = this.fireCatPerilsPremRatesPerClientGroupForm.get('remarks')?.value;
        tempInsertChecker.LAST_USER_UPDATE = this.datePipe.transform(new Date(this.fireCatPerilsPremRatesPerClientGroupForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a');
        tempInsertChecker.USER_ID = this.fireCatPerilsPremRatesPerClientGroupForm.get('userID')?.value;
        tempInsertChecker.MODE = 'I';
      } 
      else if(tempUpdateChecker!=null && tempUpdateChecker!='') {
        tempUpdateChecker.CLIENT_CD= this.paramForm.get('clientGrpCd')?.value;
        tempUpdateChecker.CLASS_CD= this.paramForm.get('classCd')?.value;
        tempUpdateChecker.LINE_CD= this.paramForm.get('lineCd')?.value;
        tempUpdateChecker.PERIL_CD= this.paramForm.get('perilCd')?.value;
        tempUpdateChecker.CAT_ZONE_CD= this.paramForm.get('catZoneCd')?.value;
        tempUpdateChecker.NO_OF_FLOOR= +this.fireCatPerilsPremRatesPerClientGroupForm.get('numOfFloor')?.value;
        tempUpdateChecker.PREM_RT  = +this.fireCatPerilsPremRatesPerClientGroupForm.get('premiumRate')?.value;
        tempUpdateChecker.ACTIVE_TAG = this.fireCatPerilsPremRatesPerClientGroupForm.get('activeTag')?.value;
        tempUpdateChecker.COMM_RT = +this.fireCatPerilsPremRatesPerClientGroupForm.get('commissionRate')?.value;
        tempUpdateChecker.DEFAULT_TAG = this.fireCatPerilsPremRatesPerClientGroupForm.get('defaultTag')?.value;
        tempUpdateChecker.EFF_DATE_FROM = this.datePipe.transform(new Date(this.fireCatPerilsPremRatesPerClientGroupForm.get('effDateFrom')?.value), 'yyyy-MM-dd');
        tempUpdateChecker.EFF_DATE_TO = fieldEffDateTo;
        tempUpdateChecker.REMARKS = this.fireCatPerilsPremRatesPerClientGroupForm.get('remarks')?.value;
        tempUpdateChecker.LAST_USER_UPDATE = this.datePipe.transform(new Date(this.fireCatPerilsPremRatesPerClientGroupForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a');
        tempUpdateChecker.USER_ID = this.fireCatPerilsPremRatesPerClientGroupForm.get('userID')?.value;
        tempUpdateChecker.MODE = 'U';
      }
      else {
        this.tempUpdateData.push(this.formValueToData());
      }
      this.saveDisabled = false;
      this.resetFormValues();
    }
    catch(e) {
    }
  }

  tableDataUpdate() {
    try {
      this.fireCatPerilsPremRatesPerClientGroupForm.patchValue({
        activeTag: this.fireCatPerilsPremRatesPerClientGroupForm.get('activeTag')?.value,
        userID: this.currentUser,
        lastUserUpdate: new Date()
      });
      let fieldEffDateTo = this.fireCatPerilsPremRatesPerClientGroupForm.get('effDateTo')?.value?new Date(this.fireCatPerilsPremRatesPerClientGroupForm.get('effDateTo')?.value):null;
      let updateIndex = this.fireCatPerilsPremRatesPerClientGroupTblConfig.tblData.indexOf(this.rowClickedData);
      
      this.fireCatPerilsPremRatesPerClientGroupTblConfig.tblData[updateIndex] = {
        CLIENT_CD: this.paramForm.get('clientGrpCd')?.value,
        CLASS_CD: this.paramForm.get('classCd')?.value,
        LINE_CD: this.paramForm.get('lineCd')?.value,
        PERIL_CD: this.paramForm.get('perilCd')?.value,
        CAT_ZONE_CD: this.paramForm.get('catZoneCd')?.value,
        NO_OF_FLOOR: +this.fireCatPerilsPremRatesPerClientGroupForm.get('numOfFloor')?.value,
        PREM_RT: +this.fireCatPerilsPremRatesPerClientGroupForm.get('premiumRate')?.value,
        ACTIVE_TAG: this.fireCatPerilsPremRatesPerClientGroupForm.get('activeTag')?.value,
        COMM_RT: +this.fireCatPerilsPremRatesPerClientGroupForm.get('commissionRate')?.value,
        DEFAULT_TAG: this.fireCatPerilsPremRatesPerClientGroupForm.get('defaultTag')?.value,
        EFF_DATE_FROM: new Date(this.fireCatPerilsPremRatesPerClientGroupForm.get('effDateFrom')?.value),
        EFF_DATE_TO: fieldEffDateTo,
        REMARKS: this.fireCatPerilsPremRatesPerClientGroupForm.get('remarks')?.value,
        LAST_USER_UPDATE: this.datePipe.transform(new Date(this.fireCatPerilsPremRatesPerClientGroupForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a'),
        USER_ID: this.fireCatPerilsPremRatesPerClientGroupForm.get('userID')?.value,
        MODE: 'U'
      };
      this.fireCatPerilsPremRatesPerClientGroupTblConfig.tblData = [...this.fireCatPerilsPremRatesPerClientGroupTblConfig.tblData];
    }
    catch(e) {
    }
  }

  formValueToData() {
    try {
      let fieldEffDateTo = this.fireCatPerilsPremRatesPerClientGroupForm.get('effDateTo')?.value? this.datePipe.transform(new Date(this.fireCatPerilsPremRatesPerClientGroupForm.get('effDateTo')?.value), 'yyyy-MM-dd'): null;
      let formToData: any = { // this.datePipe.transform(new Date(), 'MM/dd/yyyy')
        CLIENT_CD: this.paramForm.get('clientGrpCd')?.value,
        CLASS_CD: this.paramForm.get('classCd')?.value,
        LINE_CD: this.paramForm.get('lineCd')?.value,
        PERIL_CD: this.paramForm.get('perilCd')?.value,
        CAT_ZONE_CD: this.paramForm.get('catZoneCd')?.value,
        NO_OF_FLOOR: this.fireCatPerilsPremRatesPerClientGroupForm.get('numOfFloor')?.value,
        PREM_RT: this.fireCatPerilsPremRatesPerClientGroupForm.get('premiumRate')?.value,
        ACTIVE_TAG: this.fireCatPerilsPremRatesPerClientGroupForm.get('activeTag')?.value,
        COMM_RT: this.fireCatPerilsPremRatesPerClientGroupForm.get('commissionRate')?.value,
        DEFAULT_TAG: this.fireCatPerilsPremRatesPerClientGroupForm.get('defaultTag')?.value,
        EFF_DATE_FROM: this.datePipe.transform(new Date(this.fireCatPerilsPremRatesPerClientGroupForm.get('effDateFrom')?.value), 'yyyy-MM-dd'),
        ORIG_EFF_DATE_FROM: this.fireCatPerilsPremRatesPerClientGroupForm.get('effDateFrom')?.value,
        EFF_DATE_TO: fieldEffDateTo,
        REMARKS: this.fireCatPerilsPremRatesPerClientGroupForm.get('remarks')?.value,
        LAST_USER_UPDATE: this.datePipe.transform(new Date(this.fireCatPerilsPremRatesPerClientGroupForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a'),
        USER_ID: this.fireCatPerilsPremRatesPerClientGroupForm.get('userID')?.value,
        MODE: 'U'
      }
      return formToData;
    }
    catch(e) {
    }
  }
  deleteLine() {
    try {
      let clickData = this.rowClickedData;
      this.fireCatPerilsPremRatesPerClientGroupTblConfig.tblData = this.fireCatPerilsPremRatesPerClientGroupTblConfig.tblData.filter(
        function(e: any) {
          return +e.NO_OF_FLOOR!==+clickData.NO_OF_FLOOR||+e.PREM_RT !== +clickData.PREM_RT||getDateNum(new Date(e.EFF_DATE_FROM))!==getDateNum(new Date(clickData.EFF_DATE_FROM));
        }
      );
      this.tempAddedData = this.tempAddedData.filter(
        function(e: any) {
          return +e.NO_OF_FLOOR!==+clickData.NO_OF_FLOOR||+e.PREM_RT !== +clickData.PREM_RT||getDateNum(new Date(e.EFF_DATE_FROM))!==getDateNum(new Date(clickData.EFF_DATE_FROM));
        }
      );
      this.resetFormValues();
      this.appMessageService.showAppMessage("Standard Rates details deleted!", "success");
    }
    catch(e) {
    }
  }

  insertLine() {
    try {
      this.tranPosted = true;
      this.validateInsert();
      if (this.validated) {
        this.addFormToTable();
      }
    }
    catch(e) {
    }
  }
  addFormToTable() {
    try {
      this.fireCatPerilsPremRatesPerClientGroupForm.patchValue({
        activeTag: this.fireCatPerilsPremRatesPerClientGroupForm.get('activeTag')?.value,
        userID: this.currentUser,
        lastUserUpdate: new Date()
      });
      let fieldEffDateTo = this.fireCatPerilsPremRatesPerClientGroupForm.get('effDateTo')?.value? this.datePipe.transform(new Date(this.fireCatPerilsPremRatesPerClientGroupForm.get('effDateTo')?.value), 'yyyy-MM-dd'): null;
      let formToData: any = { // this.datePipe.transform(new Date(), 'MM/dd/yyyy')
        CLIENT_CD: this.paramForm.get('clientGrpCd')?.value,
        CLASS_CD: this.paramForm.get('classCd')?.value,
        LINE_CD: this.paramForm.get('lineCd')?.value,
        PERIL_CD: this.paramForm.get('perilCd')?.value,
        CAT_ZONE_CD: this.paramForm.get('catZoneCd')?.value,
        NO_OF_FLOOR: +this.fireCatPerilsPremRatesPerClientGroupForm.get('numOfFloor')?.value,
        PREM_RT: +this.fireCatPerilsPremRatesPerClientGroupForm.get('premiumRate')?.value.toUpperCase(),
        COMM_RT: +this.fireCatPerilsPremRatesPerClientGroupForm.get('commissionRate')?.value,
        EFF_DATE_FROM: this.datePipe.transform(new Date(this.fireCatPerilsPremRatesPerClientGroupForm.get('effDateFrom')?.value), 'yyyy-MM-dd'),
        EFF_DATE_TO: fieldEffDateTo,
        ACTIVE_TAG: this.fireCatPerilsPremRatesPerClientGroupForm.get('activeTag')?.value,
        DEFAULT_TAG: this.fireCatPerilsPremRatesPerClientGroupForm.get('defaultTag')?.value,
        REMARKS: this.fireCatPerilsPremRatesPerClientGroupForm.get('remarks')?.value,
        LAST_USER_UPDATE: this.datePipe.transform(new Date(this.fireCatPerilsPremRatesPerClientGroupForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a'),
        USER_ID: this.fireCatPerilsPremRatesPerClientGroupForm.get('userID')?.value,
        MODE: 'I'
      }
      this.fireCatPerilsPremRatesPerClientGroupTblConfig.tblData.unshift(formToData);
      this.fireCatPerilsPremRatesPerClientGroupTblConfig.tblData = [...this.fireCatPerilsPremRatesPerClientGroupTblConfig.tblData];
      this.tempAddedData.push(formToData);
      this.resetFormValues();
    }
    catch(e) {
    }
  }

  saveData(tempChangeData:any[]){
    this.apiCallService.saveFireCatPremiumRatesPerClientGroup(tempChangeData)
    .subscribe({
      next: (response : any) => {
        this.securityService.checkRequestKeyResponse(response, () => {
          this.securityService.hasValidCsrfToken(response, ()=>{
            if (response.status == "SUCCESS" && this.tranPosted) {
              this.openDialog('SUCCESS', 'Details Successfully saved!');
              this.initOnGet();
              this.resetFormValues();
              this.tempAddedData = [];
              this.tempUpdateData = [];
              this.saveDisabled = this.saveChecker();
            }  
            else {
              this.initOnGet();
              this.saveDisabled = this.saveChecker();
              this.openDialog('ERROR', 'An error has occured while saving details');
            }
          });
        });
      }, 
      error: () => {
        this.openDialog('ERROR', 'An error has occured while saving details');
      }
    });
  }

  toSave() {
    try {
      this.noLoadingInProcess = false;
      this.formService.showFormLoader(null, "generate-line-form", "Please wait ...", null, null);
      let tempChangeData= this.tempAddedData.concat(this.tempUpdateData);
      if(tempChangeData.length!=0) {
        for(let item of tempChangeData){
          if(item.DEFAULT_TAG.toUpperCase()=='YES'){
            item.DEFAULT_TAG = 'Y';
          }else{
            item.DEFAULT_TAG= 'N';
          }
          item.NO_OF_FLOOR = item.NO_OF_FLOOR.toString();
          item.PREM_RT = item.PREM_RT.toString();
          item.COMM_RT = item.COMM_RT.toString();
        }
        this.saveData(tempChangeData);
      } else {
        this.initOnGet();
        this.resetFormValues();
        this.tempAddedData = [];
        this.tempUpdateData = [];
        this.saveDisabled = this.saveChecker();
      }
    }
    catch(e) {
    }
  }
  saveChecker() {
    try {
      if((this.tempAddedData==null || this.tempAddedData=='') && (this.tempUpdateData==null || this.tempUpdateData=='')) {
        return true;
      }
      else {
        return false;
      }
    }
    catch(e) {
      return true;
    }
  }

  deleteChecker(ev: any) {
    try {
      let tempDataFlag;
      tempDataFlag = this.tempAddedData.filter(function(e: any) {
        return +e.NO_OF_FLOOR==+ev.NO_OF_FLOOR&&+e.PREM_RT==+ev.PREM_RT&&getDateNum(new Date(e.EFF_DATE_FROM))==getDateNum(new Date(ev.EFF_DATE_FROM));
      });
      if(tempDataFlag==''||tempDataFlag==null) {
        return true;
      } else {
        return false;
      }
    }
    catch(e) {
      return true;
    }
  }

  perilChecker(){
    try{
      let lineCd = this.paramForm.get('lineCd')?.value;
      if(lineCd!==''&&lineCd!==null){
        return false;
      }
      else{ 
        return true;
      }
    }catch(e){
      return true;
    }
  }
  
  onRowClick(ev: any) {
    try {    
      if(ev!=null) {
        this.rowClickedData = ev;
        this.fireCatPerilsPremRatesPerClientGroupForm.get('lineCode')?.disable();
        this.loadFormValues();
        this.saveDisabled = this.saveChecker();
        this.deleteDisabled = this.deleteChecker(ev);
      }
      else {
        this.resetFormValues();
      }
    }
    catch(e) {
    }
  }

  loadFormValues() {
    try {
      let premiumRate: string = '';
      let commisionRate: string= '';
      if(this.rowClickedData.PREM_RT!==''&&this.rowClickedData.PREM_RT!==null){
        premiumRate = parseFloat(this.rowClickedData.PREM_RT).toFixed(9);
      }
      if(this.rowClickedData.COMM_RT!==''&&this.rowClickedData.COMM_RT!==null){
        commisionRate = parseFloat(this.rowClickedData.COMM_RT).toFixed(9);
      }
      let fieldEffDateTo = this.rowClickedData.EFF_DATE_TO? new Date(this.rowClickedData.EFF_DATE_TO):null;
      this.fireCatPerilsPremRatesPerClientGroupForm.patchValue({
        numOfFloor: this.rowClickedData.NO_OF_FLOOR,
        premiumRate: premiumRate,
        activeTag: this.rowClickedData.ACTIVE_TAG,
        commissionRate: commisionRate,
        defaultTag: this.rowClickedData.DEFAULT_TAG,
        effDateFrom: new Date(this.rowClickedData.EFF_DATE_FROM),
        effDateTo: fieldEffDateTo,
        remarks: this.rowClickedData.REMARKS,
        userID: this.rowClickedData.USER_ID,
        lastUserUpdate: this.rowClickedData.LAST_USER_UPDATE
      });
      this.addDisabled = true;
      this.userIDReadOnly = true;
      this.isLineSelected = true;
    }
    catch(e) {
    }
  }

  resetFormValues() {
    try {
      this.selectedData = null;
      // this.paramForm.get('lineCD')?.enable();
      this.fireCatPerilsPremRatesPerClientGroupForm.patchValue({
        numOfFloor: null,
        premiumRate: null,
        activeTag: 'A',
        commissionRate: null,
        defaultTag: 'No',
        effDateFrom: new Date(),
        effDateTo: null,
        remarks: null,
        userID: null,
        lastUserUpdate: null
      });

      let clientGrpCd = this.paramForm.get('clientGrpCd')?.value;
      let lineCd = this.paramForm.get('lineCd')?.value;
      let classCd = this.paramForm.get('classCd')?.value;
      let perilCd = this.paramForm.get('perilCd')?.value;
      let catZoneCd = this.paramForm.get('catZoneCd')?.value;
      this.addDisabled = !(clientGrpCd && lineCd && classCd&& perilCd&& catZoneCd);
      this.saveDisabled = this.saveChecker();
      this.deleteDisabled = true;
      this.userIDReadOnly = false;
      this.isLineSelected = false;

      this.rowClickedData = '' || null;
    }
    catch (e) {
    console.error(e);
    }
  }

  openLineDialog() {
    try {
      this._Dialog.open(LineLovDialogComponent, {
        width: '512px',
        disableClose: true,
        data: {
          table: 'LINE',
          title: 'Line',
          col: 'LINE',
          userId: this.userDetailService.userId,
          moduleId: this.moduleId
        }
      }).afterClosed().subscribe(data => {
        if (data.content != '' && data.content != null) {
          this.selectedLine = data.content;
          this.paramForm.get('lineCd')?.setValue(this.selectedLine.LINE_CD==null || this.selectedLine.LINE_CD=='' ? '' : this.selectedLine.LINE_CD);
          this.paramForm.get('lineName')?.setValue(this.selectedLine.LINE_CD==null || this.selectedLine.LINE_CD=='' ? '' : this.selectedLine.LINE_NAME);
          this.paramForm.get('lineField')?.setValue(this.selectedLine.LINE_CD==null || this.selectedLine.LINE_CD=='' ? '' : this.selectedLine.LINE_CD + " - " + this.selectedLine.LINE_NAME);
        }
        this.paramForm.get('perilCd')?.setValue(null);
        this.paramForm.get('perilName')?.setValue(null);
        this.paramForm.get('perilField')?.setValue(null);
        this.paramForm.get('catZoneCd')?.setValue(null);
        this.paramForm.get('catZoneDesc')?.setValue(null);
        this.paramForm.get('catZoneField')?.setValue(null);
        this.resetFormValues();
        this.initOnGet();
        this.perilDisabled = this.perilChecker();
      });
    } catch(e) {
    }
  }

  openClientGroupDialog() {
    try {
      this._Dialog.open(ClientGroupLovDialog, {
        width: '512px',
        disableClose: true,
        data: {
          table: 'CLIENT_GROUP',
          title: 'Client Group',
          userId: this.userDetailService.userId,
          moduleId: this.moduleId
        }
      }).afterClosed().subscribe(data => {
        if (data.content != '' && data.content != null) {
          this.selectedClientGrp = data.content;
          this.paramForm.get('clientGrpCd')?.setValue(this.selectedClientGrp.CLIENT_CD==null || this.selectedClientGrp.CLIENT_CD=='' ? '' : this.selectedClientGrp.CLIENT_CD);
          this.paramForm.get('clientGrpDesc')?.setValue(this.selectedClientGrp.CLIENT_CD==null || this.selectedClientGrp.CLIENT_CD=='' ? '' : this.selectedClientGrp.CLIENT_DESC);
          this.paramForm.get('clientGrpField')?.setValue(this.selectedClientGrp.CLIENT_CD==null || this.selectedClientGrp.CLIENT_CD=='' ? '' : this.selectedClientGrp.CLIENT_CD + " - " + this.selectedClientGrp.CLIENT_DESC);
          this.initOnGet();
        }
        this.resetFormValues();
      });
    } catch(e) {
    }
  }
  openClassDialog() {
    try {
      this._Dialog.open(ClassLovComponent, {
        width: '512px',
        disableClose: true,
        data: {
          title: 'Property Class Code',
          col: 'CODE',
          userId: this.userDetailService.userId,
          moduleId: this.moduleId
        }
      }).afterClosed().subscribe(data => {
        if (data.content != '' && data.content != null) {
          this.selectedClass = data.content;
          
          this.paramForm.get('classCd')?.setValue(this.selectedClass.CLASS_CD==null || this.selectedClass.CLASS_CD=='' ? '' : this.selectedClass.CLASS_CD);
          this.paramForm.get('classDesc')?.setValue(this.selectedClass.CLASS_CD==null || this.selectedClass.CLASS_CD=='' ? '' : this.selectedClass.CLASS_DESC);
          this.paramForm.get('classField')?.setValue(this.selectedClass.CLASS_CD==null || this.selectedClass.CLASS_CD=='' ? '' : this.selectedClass.CLASS_CD + " - " + this.selectedClass.CLASS_DESC);
          this.initOnGet();
        }
        this.resetFormValues();
      });
    } catch(e) {
    }
  }
  openCatZoneDialog() {
    try {
      if(this.paramV == "CAT_PERIL_EQ"){
        this._Dialog.open(EQZoneLovComponent, {
          width: '512px',
          disableClose: true,
          data: {
            userId: this.userDetailService.userId,
            moduleId: this.moduleId,
            tableData: 'PLAN',
            title: 'Earthquake Zoning',
          }
        }).afterClosed().subscribe(data => {
          if (data.content != '' && data.content != null) {
            this.selectedCatZone=data.content;
            this.paramForm.get('catZoneCd')?.setValue(Number(this.selectedCatZone.EQ_ZONE_CD==null || this.selectedCatZone.EQ_ZONE_CD=='' ? '' : this.selectedCatZone.EQ_ZONE_CD));
            this.paramForm.get('catZoneDesc')?.setValue(this.selectedCatZone.EQ_ZONE_CD==null || this.selectedCatZone.EQ_ZONE_CD=='' ? '' : this.selectedCatZone.EQ_ZONE_LONG_DESC);
            this.paramForm.get('catZoneField')?.setValue(this.selectedCatZone.EQ_ZONE_CD==null || this.selectedCatZone.EQ_ZONE_CD=='' ? '' : padLeadingZeros(this.selectedCatZone.EQ_ZONE_CD, 2) + " - " + this.selectedCatZone.EQ_ZONE_LONG_DESC);
            this.initOnGet();
          }
          this.resetFormValues();
        });
      } else if(this.paramV == "CAT_PERIL_TY"){
        this._Dialog.open(TyphoonZoneLovComponent, {
          width: '512px',
          disableClose: true,
          data: {
            userId: this.userDetailService.userId,
            moduleId: this.moduleId,
            tableData: 'PLAN',
            title: 'Typhoon Zoning',
          }
        }).afterClosed().subscribe(data => {
          if (data.content != '' && data.content != null) {
            this.selectedCatZone=data.content;
            this.paramForm.get('catZoneCd')?.setValue(Number(this.selectedCatZone.TYPHOON_ZONE_CD==null || this.selectedCatZone.TYPHOON_ZONE_CD=='' ? '' : this.selectedCatZone.TYPHOON_ZONE_CD));
            this.paramForm.get('catZoneDesc')?.setValue(this.selectedCatZone.TYPHOON_ZONE_CD==null || this.selectedCatZone.TYPHOON_ZONE_CD=='' ? '' : this.selectedCatZone.TYPHOON_LONG_DESC);
            this.paramForm.get('catZoneField')?.setValue(this.selectedCatZone.TYPHOON_ZONE_CD==null || this.selectedCatZone.TYPHOON_ZONE_CD=='' ? '' : this.selectedCatZone.TYPHOON_ZONE_CD + " - " + this.selectedCatZone.TYPHOON_LONG_DESC);
            this.initOnGet();
          }
          this.resetFormValues();
        });
      } else if(this.paramV == "CAT_PERIL_FL"){
        this._Dialog.open(FloodZoneLovComponent, {
          width: '512px',
          disableClose: true,
          data: {
            userId: this.userDetailService.userId,
            moduleId: this.moduleId,
            tableData: 'PLAN',
            title: 'Flood Zoning',
          }
        }).afterClosed().subscribe(data => {
          if (data.content != '' && data.content != null) {
            this.selectedCatZone=data.content;
            this.paramForm.get('catZoneCd')?.setValue(Number(this.selectedCatZone.FLOOD_ZONE_CD==null || this.selectedCatZone.FLOOD_ZONE_CD=='' ? '' : this.selectedCatZone.FLOOD_ZONE_CD));
            this.paramForm.get('catZoneDesc')?.setValue(this.selectedCatZone.FLOOD_ZONE_CD==null || this.selectedCatZone.FLOOD_ZONE_CD=='' ? '' : this.selectedCatZone.FLOOD_LONG_DESC);
            this.paramForm.get('catZoneField')?.setValue(this.selectedCatZone.FLOOD_ZONE_CD==null || this.selectedCatZone.FLOOD_ZONE_CD=='' ? '' : this.selectedCatZone.FLOOD_ZONE_CD + " - " + this.selectedCatZone.FLOOD_LONG_DESC);
            this.initOnGet();
          }
          this.resetFormValues();
        });
      }
      
    } catch(e) {
    }
  }
  openPerilDialog() {
    try {
      this._Dialog.open(PerilLovComponent, {
        width: '512px',
        disableClose: true,
        data: {
          table: 'PERIL',
          title: 'Peril',
          col:'PERIL',
          lineCd: this.paramForm.get('lineCd')?.value,
          userId: this.userDetailService.userId,
          moduleId: this.moduleId
        }
      }).afterClosed().subscribe(data => {
        if (data.content != '' && data.content != null) {
          this.selectedPeril = data.content;
          this.paramForm.get('perilCd')?.setValue(this.selectedPeril.PERIL_CD==null || this.selectedPeril.PERIL_CD=='' ? '' : padLeadingZeros(this.selectedPeril.PERIL_CD, 3));
          this.paramForm.get('perilName')?.setValue(this.selectedPeril.PERIL_CD==null || this.selectedPeril.PERIL_CD=='' ? '' : this.selectedPeril.PERIL_LNAME);
          this.paramForm.get('perilField')?.setValue(this.selectedPeril.PERIL_CD==null || this.selectedPeril.PERIL_CD=='' ? '' : padLeadingZeros(this.selectedPeril.PERIL_CD, 3) + " - " + this.selectedPeril.PERIL_LNAME);
          
        }
        this.paramForm.get('catZoneCd')?.setValue(null);
        this.paramForm.get('catZoneDesc')?.setValue(null);
        this.paramForm.get('catZoneField')?.setValue(null);
        this.resetFormValues();
        this.initOnGet();  
        this.paramV = this.paramVList.find((data:any)=>{
          let perilCd = (+this.paramForm.get('perilCd')?.value).toString();
          let paramCdlist = data.paramValueV.split(",");
          return paramCdlist.includes(perilCd);
        })?.paramName;

        if(this.paramV && ['HA'].includes(this.paramForm.get('lineCd')?.value)){
          this.catZoneDisabled = false;
        }else{
          this.paramV = '';
          this.catZoneDisabled = true;
        }
      });
    } catch(e) {
    }
  }
  openDialog(title: any, message: any) {
    try {
      this.noLoadingInProcess = true;
      this.formService.hideFormLoader("generate-line-form");
      this._Dialog.open(DialogMsgComponent, { 
        disableClose: true,
        width: "500px",
        data: {
          title: title,
          content: message
        } 
      });
    } catch(e) {
    }
  }

  validateInsert() {
    try {
      this.validated = false;
      if (!this.requiredFieldCheck()){
        setTimeout(()=>{                           //10 secs countdown
          this.formService.hideFormMsg("fire-cat-perils-premium-rates-per-client-group-error-message");
        }, 10000);
      }
      else if (!this.duplicateCheck(this.fireCatPerilsPremRatesPerClientGroupTblConfig.tblData)) {
        setTimeout(()=>{                           
          this.formService.hideFormMsg("fire-cat-perils-premium-rates-per-client-group-error-message");
        }, 10000);
      }
      else if(!this.defaultTagCheck(this.fireCatPerilsPremRatesPerClientGroupTblConfig.tblData)){
        setTimeout(()=>{                           
          this.formService.hideFormMsg("fire-cat-perils-premium-rates-per-client-group-error-message");
        }, 10000);
      }
      else if (this.effDateToCheck()) {
       setTimeout(()=>{                           
          this.formService.hideFormMsg("fire-cat-perils-premium-rates-per-client-group-error-message");
        }, 10000);
      }
      else if(this.rateCheck('premiumRate')){
        setTimeout(()=>{                           
          this.formService.hideFormMsg("fire-cat-perils-premium-rates-per-client-group-error-message");
        }, 10000);
      }
      else if(this.rateCheck('commissionRate')){
        setTimeout(()=>{                           
          this.formService.hideFormMsg("fire-cat-perils-premium-rates-per-client-group-error-message");
        }, 10000);
      }
      else {
        this.validated = true;
      }
    }
    catch (e) {
    console.error(e);
    }
  }

  requiredFieldCheck() {
    try {
      if(this.paramForm.get('clientGrpCd')?.value==='' || this.paramForm.get('clientGrpCd')?.value===null
        ||this.paramForm.get('classCd')?.value==='' || this.paramForm.get('classCd')?.value===null
        ||this.paramForm.get('lineCd')?.value==='' || this.paramForm.get('lineCd')?.value===null
        ||this.paramForm.get('catZoneCd')?.value==='' || this.paramForm.get('catZoneCd')?.value===null
        ||this.paramForm.get('perilCd')?.value==='' || this.paramForm.get('perilCd')?.value===null
        ||this.fireCatPerilsPremRatesPerClientGroupForm.get('premiumRate')?.value==='' || this.fireCatPerilsPremRatesPerClientGroupForm.get('premiumRate')?.value===null 
        || this.fireCatPerilsPremRatesPerClientGroupForm.get('activeTag')?.value==='' || this.fireCatPerilsPremRatesPerClientGroupForm.get('activeTag')?.value===null 
        || this.fireCatPerilsPremRatesPerClientGroupForm.get('commissionRate')?.value==='' || this.fireCatPerilsPremRatesPerClientGroupForm.get('commissionRate')?.value===null
        || this.fireCatPerilsPremRatesPerClientGroupForm.get('effDateFrom')?.value==='' || this.fireCatPerilsPremRatesPerClientGroupForm.get('effDateFrom')?.value===null
        || this.fireCatPerilsPremRatesPerClientGroupForm.get('numOfFloor')?.value==='' || this.fireCatPerilsPremRatesPerClientGroupForm.get('numOfFloor')?.value===null) {
        this.formService.showFormMsg("fire-cat-perils-premium-rates-per-client-group-error-message", 'There are missing information. Please provide the necessary information needed.', "E");
        return false;
      }
      else {
        return true;
      }
   }
    catch (e) {
    console.error(e);
      return false;
    }
  }
  validateUpdate() {
    try {
      this.validated = false;
      let fieldNoOfFloor = this.fireCatPerilsPremRatesPerClientGroupForm.get('numOfFloor')?.value;
      let fieldPremiumRate = parseFloat(this.fireCatPerilsPremRatesPerClientGroupForm.get('premiumRate')?.value);
      let fieldEffDateFrom= getDateNum(new Date(this.fireCatPerilsPremRatesPerClientGroupForm.get('effDateFrom')?.value));
      let filteredTblData = this.fireCatPerilsPremRatesPerClientGroupTblConfig.tblData.filter(function(e:any){
        let effDateFrom = getDateNum(new Date(e.EFF_DATE_FROM));
        let ePremRT = parseFloat(e.PREM_RT);
        let eNumOfFloor = e.NO_OF_FLOOR;
        if(ePremRT!=fieldPremiumRate||effDateFrom!=fieldEffDateFrom||eNumOfFloor!==fieldNoOfFloor){
          return true
        }
        else{
          return false
        }
      });
      if (!this.requiredFieldCheck()){
        setTimeout(()=>{                          
          this.formService.hideFormMsg("fire-cat-perils-premium-rates-per-client-group-error-message");
        }, 10000);
      }
      else if (!this.duplicateCheck(filteredTblData)) {
        setTimeout(()=>{                           
          this.formService.hideFormMsg("fire-cat-perils-premium-rates-per-client-group-error-message");
        }, 10000);
      }
      else if(!this.defaultTagCheck(filteredTblData)){
        setTimeout(()=>{                           
          this.formService.hideFormMsg("fire-cat-perils-premium-rates-per-client-group-error-message");
        }, 10000);
      }
      else if (this.effDateToCheck()) {
        setTimeout(()=>{                           
          this.formService.hideFormMsg("fire-cat-perils-premium-rates-per-client-group-error-message");
        }, 10000);
      }
      else if(this.rateCheck('commissionRate')){
        setTimeout(()=>{                           
          this.formService.hideFormMsg("fire-cat-perils-premium-rates-per-client-group-error-message");
        }, 10000);
      }
      else {
        this.validated = true;
      }
    }
    catch (e) {
    console.error(e);
    }
  }
  duplicateCheck(tblData:any) {
    try {
      let fieldNoOfFloor = this.fireCatPerilsPremRatesPerClientGroupForm.get('numOfFloor')?.value;
      let fieldPremiumRate = parseFloat(this.fireCatPerilsPremRatesPerClientGroupForm.get('premiumRate')?.value);
      let fieldEffDateToValue = this.fireCatPerilsPremRatesPerClientGroupForm.get('effDateTo')?.value;
      let fieldEffDateFrom= getDateNum(new Date(this.fireCatPerilsPremRatesPerClientGroupForm.get('effDateFrom')?.value));
      let fieldEffDateTo= getDateNum(new Date(fieldEffDateToValue))
      this.pubUserStdRatesCodeField = tblData.filter(function(e: any) {
        let effDateFrom = getDateNum(new Date(e.EFF_DATE_FROM));
        let effDateTo = getDateNum(new Date(e.EFF_DATE_TO));
        let ePremRT = parseFloat(e.PREM_RT);
        let eNumOfFloor = e.NO_OF_FLOOR;
        if(eNumOfFloor!==fieldNoOfFloor){
          return false
        }
        if(ePremRT!==fieldPremiumRate){
          return false
        }
        if(ePremRT!==fieldPremiumRate){
          return false
        }
        if(fieldEffDateToValue==''||fieldEffDateToValue==null){//possible issue
          if(e.EFF_DATE_TO==''||e.EFF_DATE_TO==null){
            return true
          }
          return fieldEffDateFrom<=effDateTo;
        }
        if(e.EFF_DATE_TO==''||e.EFF_DATE_TO==null){
          return effDateFrom<=fieldEffDateTo;
        }
        if(fieldEffDateFrom>=effDateFrom&&fieldEffDateTo<=effDateTo){
            return true;
        }
        if(fieldEffDateFrom<=effDateFrom&&fieldEffDateTo>=effDateTo){
          return true;
        }
        if(fieldEffDateFrom<=effDateFrom&&fieldEffDateTo>=effDateFrom){
          return true;
        }
        if(fieldEffDateFrom<=effDateTo&&fieldEffDateTo>=effDateTo){
          return true;
        }
        return false;
      });
      if(this.pubUserStdRatesCodeField=='' || this.pubUserStdRatesCodeField==null) {
        return true;
      } else {
        this.formService.showFormMsg("fire-cat-perils-premium-rates-per-client-group-error-message", 'Unable to add record. Premium rate within the entered effectivity period under the same No. of Floors already exists.', "E");
        return false;
      }
    }
    catch (e) {
    console.error(e);
      return false;
    }
  } 
  defaultTagCheck(tblData:any){
    try {
      let fieldNoOfFloor = this.fireCatPerilsPremRatesPerClientGroupForm.get('numOfFloor')?.value;
      let fieldDefaultTag = this.fireCatPerilsPremRatesPerClientGroupForm.get('defaultTag')?.value;
      let fieldEffDateToValue = this.fireCatPerilsPremRatesPerClientGroupForm.get('effDateTo')?.value;
      let fieldEffDateFrom= getDateNum(new Date(this.fireCatPerilsPremRatesPerClientGroupForm.get('effDateFrom')?.value));
      let fieldEffDateTo= getDateNum(new Date(fieldEffDateToValue))
      this.pubUserStdRatesCodeField = tblData.filter(function(e: any) {
        let effDateFrom = getDateNum(new Date(e.EFF_DATE_FROM));
        let effDateTo = getDateNum(new Date(e.EFF_DATE_TO));
        let eNumOfFloor = e.NO_OF_FLOOR;
        if(+eNumOfFloor!==+fieldNoOfFloor){
          return false
        }
        if(fieldDefaultTag!=='Yes'||e.DEFAULT_TAG!='Yes'){
            return false;
        }
        if(effDateFrom===fieldEffDateFrom){//possible issue
          return true;
        }
        if(fieldEffDateToValue==''||fieldEffDateToValue==null){
          if(e.EFF_DATE_TO==''||e.EFF_DATE_TO==null){
            return true
          }
          return fieldEffDateFrom<=effDateTo;
        }
        if(e.EFF_DATE_TO==''||e.EFF_DATE_TO==null){
          return effDateFrom<=fieldEffDateTo;
        }
        if(fieldEffDateFrom>=effDateFrom&&fieldEffDateTo<=effDateTo){
          return true;
        }
        if(fieldEffDateFrom<=effDateFrom&&fieldEffDateTo>=effDateTo){
          return true;
        }
        if(fieldEffDateFrom<=effDateFrom&&fieldEffDateTo>=effDateFrom){
          return true;
        }
        if(fieldEffDateFrom<=effDateTo&&fieldEffDateTo>=effDateTo){
          return true;
        }
        else{
          return false;
        }
      });
      if(this.pubUserStdRatesCodeField=='' || this.pubUserStdRatesCodeField==null) {
        return true;
      } else {
        this.formService.showFormMsg("fire-cat-perils-premium-rates-per-client-group-error-message", 'Unable to add record. Default rate for the effectivity period already exists. Only one record should be tagged as default under the same period of effectivity under the same No. of Floors.', "E");
        return false;
      }
    }
    catch (e) {
    console.error(e);
      return false;
    }
  }
  effDateToCheck(){
    try{
      let pubUserStdRatesEffDateFrom= new Date(this.fireCatPerilsPremRatesPerClientGroupForm.get('effDateFrom')?.value).getTime();
      if(this.fireCatPerilsPremRatesPerClientGroupForm.get('effDateTo')?.value!==''&&this.fireCatPerilsPremRatesPerClientGroupForm.get('effDateTo')?.value!==null){
        let pubUserStdRatesEffDateTo= new Date(this.fireCatPerilsPremRatesPerClientGroupForm.get('effDateTo')?.value).getTime();
        if(pubUserStdRatesEffDateTo<pubUserStdRatesEffDateFrom){
          this.formService.showFormMsg("fire-cat-perils-premium-rates-per-client-group-error-message", 'Unable to add record. Expiry Date must not be earlier than Effective Date', "E");
          return true
        }
        else{
          return false
        }
      }
      else{
        return false;
      }
    }
    catch (e) {
    console.error(e);
      return false;
    }
  }
  rateCheck(fieldName:string){
    let rate = parseFloat(this.fireCatPerilsPremRatesPerClientGroupForm.get(fieldName)?.value);
    let fieldRate = this.fireCatPerilsPremRatesPerClientGroupForm.get(fieldName)?.value;
    let fieldLabel = '';
    if(fieldName=='premiumRate'){
      fieldLabel = 'Premium Rate'
    }
    else if(fieldName=='commissionRate'){
      fieldLabel = 'Commission Rate'
    }
    if(fieldRate===''||fieldRate===null){
      return false
    }
    if(rate<0){
      this.formService.showFormMsg("fire-cat-perils-premium-rates-per-client-group-error-message", 'Invalid value in '+fieldLabel+' field. The value entered is a negative number', "E");
      return true;
    }
    if(rate<1000){
      return false
    }
    else{
      this.formService.showFormMsg("fire-cat-perils-premium-rates-per-client-group-error-message", 'Invalid value in '+fieldLabel+' field. The value entered exceeded the maximum limit', "E");
      return true
    }
  }
  
  rateFormat(fieldName:string){
    if(this.fireCatPerilsPremRatesPerClientGroupForm.get(fieldName)?.value!==''&&this.fireCatPerilsPremRatesPerClientGroupForm.get(fieldName)?.value!==null){
      let fieldFloat = parseFloat(this.fireCatPerilsPremRatesPerClientGroupForm.get(fieldName)?.value.replace(/,/g, ''))
      let fieldRate = fieldFloat.toFixed(9);
      if(isNaN(fieldFloat)||fieldRate=='NaN'){
        this.fireCatPerilsPremRatesPerClientGroupForm.get(fieldName)?.setValue('');
      }
      else{
        this.fireCatPerilsPremRatesPerClientGroupForm.get(fieldName)?.setValue(fieldRate);
      }
    }
  }
  numberFormat(fieldName:string){
    if(this.fireCatPerilsPremRatesPerClientGroupForm.get(fieldName)?.value!==null&&this.fireCatPerilsPremRatesPerClientGroupForm.get(fieldName)?.value!==''){
      let fieldNum = this.fireCatPerilsPremRatesPerClientGroupForm.get(fieldName)?.value.replace(/,/g, '');
      let sNum = fieldNum+"";
      if(isNaN(fieldNum)||fieldNum=='NaN'){
        this.fireCatPerilsPremRatesPerClientGroupForm.get(fieldName)?.setValue('');
      }
      else{
        while (sNum.length < 2) sNum = "0" + sNum;
        this.fireCatPerilsPremRatesPerClientGroupForm.get(fieldName)?.setValue(sNum);
      }
    }
  }
  datePattern(ev: any) {
    try{
      //let inputChar = String.fromCharCode(event.charCode)
      if (ev.target.value.length<4) {
        let firstPattern = /^\d{2}\/$/;
        if(!ev.target.value.match(firstPattern)){
          ev.target.value = ev.target.value.substring(0,2);
        }
      } else if(ev.target.value.length<7){
        let firstPattern = /^\d{2}\/\d{2}\/$/;
        if(!ev.target.value.match(firstPattern)){
          ev.target.value = ev.target.value.substring(0,5);
        }
      } else if(ev.target.value.length>6&&ev.target.value.length<11){
        let firstPattern = /^\d{2}\/\d{2}\/\d+$/;
        if(!ev.target.value.match(firstPattern)){
          ev.target.value = ev.target.value.substring(0,ev.target.value.length-1);
        }
      } else if(ev.target.value.length==10){
        let firstPattern = /^\d{2}\/\d{2}\/\d{4}$/;
        if(!ev.target.value.match(firstPattern)){
          ev.target.value = ev.target.value.substring(0,ev.target.value.length-1);
        }
      } else{
        ev.target.value = ev.target.value.substring(0,ev.target.value.length-1);
      }
    }
    catch(e) {
    }
  }
}
function getDateNum(dateInput:Date){
  if(dateInput==null){
    return 0;
  }
  let year = dateInput.getFullYear();
  let month = dateInput.getMonth()+1;
  let day = dateInput.getDate();
  let resultString = year+""+padLeadingZeros(month, 2)+""+padLeadingZeros(day, 2);
  
  let result = parseInt(resultString);
  return result;
}
function padLeadingZeros(num:number, size:number) {
  let sNum = num+"";
  while (sNum.length < size) sNum = "0" + sNum;
  return sNum;
}